import styles from "./bussiness.module.css";
import ReactDOM from "react-dom";
import axios from "axios";
import { useState, useEffect } from "react";
import { connection } from "utils/apiConnection.ts";
import { AiFillLeftCircle } from "react-icons/ai";
import { AiOutlinePlus } from "react-icons/ai";
import Modal from "./modal/Modal";
import FilterProduct from "./modal/FilterProduct";
import toast from "react-hot-toast";
import BoxCustomer from "./BoxCustomer";
import { FaFilter, FaTrashAlt } from "react-icons/fa";
import Filter from "./modal/Filter";
import AddCampain from "./modal/AddCampain";
import pro from "assets/images/pro.png";
import BoxProduct from "./BoxProduct";
import EditProduct from "./modal/EditProduct";
import _ from "lodash";
import ReactPaginate from "react-paginate";
import AddProduct from "./modal/AddProduct";
import DeleteProduct from "./modal/DeleteProduct";
import StopProduct from "./modal/StopProduct";
import Loader from "utils/Loader";
const Product = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [allProductTags, setAllProductTags] = useState([]);
  const [allLeader, setAllLeader] = useState([]);
  const [allUserTag, setAllUserTag] = useState([
    { label: "", value: "", id: 0, default_price: 0, default_need_time: 0 }
  ]);
  const [selectedItem, setSelectedItem] = useState(1);
  const [updater, setUpdater] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [todos, setTodos] = useState([]);
  const [pageNumber, setPageNumber] = useState(0);
  const usersPerPage = 12;
  const pageVisited = pageNumber * usersPerPage;
  const pageCountt = Math.ceil(customers.length / usersPerPage);
  const changePage = ({ selected }) => {
    setPageNumber(selected);
  };
  const [otherInfo, setOtherInfo] = useState({
    available_order_option_ids: [],
    title: "",
    cat_id: "",
    default_price: "",
    default_weight_from: [],
    default_weight_to: "",
    products__id: "",
    line_id: [],
    sub_line_id: [],
    path: "",
    main_cover_file_id: "",
    discription: "",
    filename: [],
    send_type: "",
    status: [],
    sum_product_rate: "",
    count_product_rate: "",
    total_inventory: "",
    total_supplier_count: "",
    best_supplier_id: ""
  });
  useEffect(() => {
    setIsLoading(true);
    async function loadPage() {
      let result = await connection("superadminapi/get_list_product", {});
      let x = result.list;

      setCustomers(x);
      setIsLoading(false);
    }
    loadPage();
  }, [updater]);

  useEffect(() => {
    async function loadPage() {
      let data = await connection(
        "superadminapi/get_add_edit_product_data",
        {}
      );
      let allProductTags = [];
      for (let index = 0; index < data.lines.length; index++) {
        let newObject = {};
        newObject.value = data.lines[index].id;
        newObject.label = data.lines[index].title;
        newObject.main_cat = data.lines[index].main_cat;
        newObject.parent_line_id = data.lines[index].parent_line_id;
        allProductTags.push(newObject);
      }
      setAllProductTags(allProductTags);
    }
    loadPage();
  }, []);

  useEffect(() => {
    async function loadPage() {
      let data = await connection(
        "superadminapi/get_add_edit_product_data",
        {}
      );
      let allLeader = [];
      for (let index = 0; index < data.cats.length; index++) {
        let newObject = {};
        newObject = data.cats[index];

        allLeader.push(newObject);
      }

      setAllLeader(allLeader);
    }
    loadPage();
  }, []);
  useEffect(() => {
    async function loadPage() {
      let data = await connection(
        "superadminapi/get_add_edit_product_data",
        {}
      );

      var allUserTagTemp = [];
      for (let index = 0; index < data.avb_options.length; index++) {
        let newObject = {};
        newObject.value = data.avb_options[index].id;
        newObject.label = data.avb_options[index].title;
        newObject.default_need_time = data.avb_options[index].default_need_time;
        newObject.default_price = data.avb_options[index].default_price;
        allUserTagTemp.push(newObject);
      }
      setAllUserTag(allUserTagTemp);
    }
    loadPage();
  }, []);
  let chars = _.orderBy(customers, ["mtm"], ["desc"]);
  const [filterInputs, setFilterInputs] = useState({
    title: "",
    order_count_from: "",
    order_count_to: "",
    unit_price_from: "",
    unit_price_to: "",
    supplier_count_from: "",
    supplier_count_to: "",
    add_to_basket_count_from: "",
    add_to_basket_count_to: "",
    total_inventory_count_from: "",
    total_inventory_count_to: ""
  });
  async function search() {
    setIsLoading(true);
    let myFormData = new FormData();

    if (filterInputs.title !== "") {
      myFormData.append("keyword", filterInputs.title);
    }
    if (filterInputs.order_count_from !== "") {
      myFormData.append("order_count_from", filterInputs.order_count_from);
    }
    if (filterInputs.order_count_to !== "") {
      myFormData.append("order_count_to", filterInputs.order_count_to);
    }
    if (filterInputs.unit_price_from !== "") {
      myFormData.append("unit_price_from", filterInputs.unit_price_from);
    }
    if (filterInputs.unit_price_to !== "") {
      myFormData.append("unit_price_to", filterInputs.unit_price_to);
    }
    if (filterInputs.supplier_count_from !== "") {
      myFormData.append(
        "supplier_count_from",
        filterInputs.supplier_count_from
      );
    }
    if (filterInputs.supplier_count_to !== "") {
      myFormData.append("supplier_count_to", filterInputs.supplier_count_to);
    }
    if (filterInputs.add_to_basket_count_from !== "") {
      myFormData.append(
        "add_to_basket_count_from",
        filterInputs.add_to_basket_count_from
      );
    }
    if (filterInputs.add_to_basket_count_to !== "") {
      myFormData.append(
        "add_to_basket_count_to",
        filterInputs.add_to_basket_count_to
      );
    }
    if (filterInputs.total_inventory_count_from !== "") {
      myFormData.append(
        "total_inventory_count_from",
        filterInputs.total_inventory_count_from
      );
    }
    if (filterInputs.total_inventory_count_to !== "") {
      myFormData.append(
        "total_inventory_count_to",
        filterInputs.total_inventory_count_to
      );
    }

    axios
      .post(
        "http://old-sabadib.tatdemo.ir/superadminapi/get_list_product",
        myFormData
      )
      .then(res => {
        console.log("res", res.data.list.map(v => v));
        setCustomers(res.data.list);
        setIsLoading(false);
      });
  }
  async function resetFilters() {
    setIsLoading(true);
    setFilterInputs({
      title: "",
      order_count_from: "",
      order_count_to: "",
      unit_price_from: "",
      unit_price_to: "",
      supplier_count_from: "",
      supplier_count_to: "",
      add_to_basket_count_from: "",
      add_to_basket_count_to: "",
      total_inventory_count_from: "",
      total_inventory_count_to: ""
    });

    setUpdater(!updater);
    setIsLoading(false);
  }
  const deleteHandler = id => {
    setIsLoading(true);
    let myFormData = new FormData();
    myFormData.append("keyvalues", `product_status,-1`);
    myFormData.append("conditions", `id/=/${id}`);
    axios
      .post(`http://old-sabadib.tatdemo.ir/api/Update_products`, myFormData)
      .then(res => {
        if (res.data.status == 1) {
          toast.success("  کالا با موفقیت حذف شد");
          setUpdater(!updater);
          setIsLoading(false);
        } else {
          toast.error("  خطا در حذف کردن  کالا!");
          setIsLoading(false);
        }
      });
  };
  const stopHandler = id => {
    setIsLoading(true);
    let myFormData = new FormData();
    myFormData.append("keyvalues", `product_status,-2`);
    myFormData.append("conditions", `id/=/${id}`);
    axios
      .post(`http://old-sabadib.tatdemo.ir/api/Update_products`, myFormData)
      .then(res => {
        if (res.data.status == 1) {
          toast.success("  کالا با موفقیت متوقف شد");
          setIsLoading(false);
          setUpdater(!updater);
        } else {
          toast.error("  خطا در متوقف کردن  کالا!");
          setIsLoading(false);
        }
      });
  };

  return (
    <div className="container w-100">
      {isLoading && <Loader></Loader>}
      {chars.length > 0 ? (
        chars
          .slice(pageVisited, pageVisited + usersPerPage)
          .map((item, index) => {
            return (
              <div>
                <BoxProduct
                  allUserTag={allUserTag}
                  setAllUserTag={setAllUserTag}
                  allLeader={allLeader}
                  setAllLeader={setAllLeader}
                  allProductTags={allProductTags}
                  setAllProductTags={setAllProductTags}
                  item={item}
                  key={item.id}
                  customers={customers}
                  todos={todos}
                  setTodos={setTodos}
                  selectedItem={selectedItem}
                  setSelectedItem={setSelectedItem}
                  setCustomers={setCustomers}
                  index={index}
                  otherInfo={otherInfo}
                  setOtherInfo={setOtherInfo}
                  deleteHandler={() => deleteHandler(item.id)}
                  stopHandler={() => stopHandler(item.id)}
                />
              </div>
            );
          })
      ) : (
        <p> محصول وجود ندارد</p>
      )}
      <div className=" d-flex justify-conteny-center">
        <ReactPaginate
          previousLabel={"قبلی"}
          nextLabel={"بعدی"}
          pageRangeDisplayed={2}
          marginPagesDisplayed={0}
          pageCount={pageCountt}
          onPageChange={changePage}
          containerClassName={"paginationBttn"}
          activeClassName={"paginationActive"}
          disabledClassName={"paginationDisabled"}
          nextLinkClassName={"nextBttn"}
          previousLinkClassName={"previousBttn"}
        />
      </div>

      <FilterProduct
        filterInputs={filterInputs}
        setFilterInputs={setFilterInputs}
        search={search}
        resetFilters={resetFilters}
      />
      {/* <Filter /> */}
      {ReactDOM.createPortal(
        <AddProduct
          setIsLoading={setIsLoading}
          setCustomers={setCustomers}
          setUpdater={setUpdater}
          updater={updater}
        />,
        document.getElementById("modals")
      )}
      <EditProduct
        setIsLoading={setIsLoading}
        allProductTags={allProductTags}
        setAllProductTags={setAllProductTags}
        allLeader={allLeader}
        setAllLeader={setAllLeader}
        todos={todos}
        setTodos={setTodos}
        allUserTag={allUserTag}
        setAllUserTag={setAllUserTag}
        otherInfo={otherInfo}
        setOtherInfo={setOtherInfo}
        setUpdater={setUpdater}
        updater={updater}
        setCustomers={setCustomers}
      />
      {/* <!--Modal Trash--> */}
      <DeleteProduct
        index={selectedItem}
        customers={customers}
        deleteHandler={deleteHandler}
      />
      <StopProduct
        index={selectedItem}
        customers={customers}
        stopHandler={stopHandler}
      />
      {/* <!--Modal Edit--> */}
    </div>
  );
};

export default Product;
